// extracted by mini-css-extract-plugin
export default {"userSection":"App_userSection__2jkIW","msModalContainer":"App_msModalContainer__ZTtnp","msOverlay":"App_msOverlay__xmKII","msModal":"App_msModal__+sQM+"};